import React from 'react'

const Map = () => {
    const mapData = [
        {
            alphabet: 'A',
            denotes: 'Main Entry'
        },
        {
            alphabet: 'B',
            denotes: 'Bedroom'
        },
        {
            alphabet: 'C',
            denotes: 'Dining Room'
        },
        {
            alphabet: 'D',
            denotes: 'Full Kitchen'
        },
        {
            alphabet: 'E',
            denotes: 'Shower'
        },
        {
            alphabet: 'F',
            denotes: 'Bathroom'
        }
    ];
    
    return (
        <div className='flex flex-col md:flex-row py-4'>
            <img src="/images/map.webp" alt="" className='w-full md:max-w-[80%]' />
            <div className='flex md:flex-col flex-wrap item-center justify-center md:space-y-3 px-1 md:px-0'>
                {
                    mapData.map((data, index)=> (
                        <p className='flex flex-wrap text-[18px] mr-4 mb-4 md:mb-0 text-[#1b1b1b]'><strong>{data.alphabet} - </strong> {data.denotes}</p>
                    ))
                }
            </div>
        </div>
    )
}

export default Map